<template>
  <div>

    <div class="text-center">
    <v-dialog
      v-model="soundDialog"
      width="500"
    >
      <v-card>
        <v-card-title class="text-h5">
          Καλωσορίσατε
        </v-card-title>

        <v-card-text>
          Παρακαλώ πατήστε στο παρακάτω κουμπί για να ενεργοποιήσετε τους ήχους συναγερμού.
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="soundDialog = false; alertSoundCheck()"
          >
            Ενεργοποίηση ήχων
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>

    <BatteryNotification v-if="!this.$store.state.batteryDialogDismissed" />
    <div style="position: absolute; width: 100%;" class="d-flex flex-row-reverse">
    <v-card style="z-index: 200; height: 105vh;" class="mb-2 mr-4 pr-14 d-inline-flex">
      <v-card-text>
        <v-list three-line>
          <v-subheader><b>Συναγερμοί</b></v-subheader>
          <template v-for="[index, item] of Object.entries(this.events)">
            <v-list-item
              :key="item.id"
              class="mt-1"
              v-if="item.activity"
            >
              <v-list-item-content class="text-left align-self-start mt-2">
                <v-list-item-title><b>{{ item.camp }} - {{ item.sensorDescription }}</b>: {{ convertTime(item.timestamp) }}</v-list-item-title>
                <v-list-item-subtitle>
                  {{ item.sensorIndex == 3 ? 'Χαμηλή Μπαταρία' : (item.sensorIndex == 4 ? 'Check' : (item.sensorIndex == 5 ? 'Συναγερμός' : `Φωτιά (${item.sensorIndex})`))}}
                </v-list-item-subtitle>                
              </v-list-item-content>

              <v-btn v-if="item.sensorIndex == 5" color="orange" class="mb-3" @click="confirmAlert(item)" :disabled="item.confirmations.length > 0">OK</v-btn>
              <v-btn v-else-if="item.sensorIndex < 3" color="red" class="mb-3" @click="confirmAlert(item)" :disabled="item.confirmations.length > 0">OK</v-btn>
              <v-btn v-else color="yellow" class="mb-3" @click="confirmAlert(item)" :disabled="item.confirmations.length > 0">OK</v-btn>
            </v-list-item>

            <v-divider
              :key="index"
            ></v-divider>

          </template>

        </v-list>
      </v-card-text>
    </v-card>
    </div>

  <v-card class="mr-4">
    <div v-if="this.$store.state.user.isAdmin">
      <v-card-title class="mb-1 pb-0">
        Φίλτρα
      </v-card-title>
      
      <v-card-text class="mb-0 pb-0">
        <v-row>
        <v-text-field label="Περιοχή Ευθύνης" v-model="selectedCamp" style="max-width: 200px;" class="mx-4 mb-0"></v-text-field>
          
        <CampPicker style="max-width: 400px" :camps="campFilters" ref="campPicker" class="mx-1 mb-0"/>

        <v-btn color="blue" @click="filter" class="align-left mx-2 mb-0">
          ΦΙΛΤΡΑΡΙΣΜΑ
        </v-btn>

        <v-btn @click="clearFilters" class="align-left mx-2 mb-0">
          ΕΚΚΑΘΑΡΙΣΗ ΦΙΛΤΡΩΝ
        </v-btn>
        </v-row>
      </v-card-text>

    </div>
    <p style="color: red;"> {{ error }} </p>

    <!-- Sensor Details Dialog -->
        <v-dialog
          max-width="90vw"
          v-model="dialog"
          style="z-index: 1000"
        >
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >Πληροφορίες Αισθητήρα</v-toolbar>
              <v-card-text v-if="selectedSensor != null">
                <SensorDetails :sensorId="selectedSensor.id" />
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                  text
                  @click="closeSensorDetailsDialog"
                >Close</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- WeatherStation Details Dialog -->
        <v-dialog
          max-width="90vw"
          v-model="stationDialog"
          style="z-index: 1000"
        >
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >Πληροφορίες Σταθμού Καιρού</v-toolbar>
              <v-card-text v-if="selectedStation != null">
                <StationDetails :stationId="selectedStation.id" />
              </v-card-text>
              <v-card-actions class="justify-end">
                <v-btn
                  text
                  @click="closeStationDetailsDialog"
                >Close</v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
    <!-- MAP -->
    <div id="mapContainer" style="height: 90vh; width: 97.5vw; z-index: 0;" class="mt-0 pt-0"></div>
  </v-card>
  </div>
</template>

<script>
import Vue from 'vue'

import CampPicker from '@/components/CampPicker.vue'

import "leaflet/dist/leaflet.css";
import L from "leaflet";
// import { LMap,LMarker, LTileLayer} from 'vue2-leaflet';

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

import { url } from '@/plugins/axios'
import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'

import SensorDetails from '@/components/SensorDetails.vue'
import StationDetails from '@/components/StationDetails.vue'
import BatteryNotification from '@/components/BatteryNotification.vue'

export default {
  name: 'Dashboard',
  components: {
    SensorDetails,
    StationDetails,
    CampPicker,
    BatteryNotification,
  },
  data: () => {
    return {
      error: "",
      selectedCamp: "",
      alertAudio: null,
      beepAudio: null,
      sensors: [],
      weatherStations: [],
      campFilters: [],
      selectedSensorIndex: null,
      events: {},
      connection: undefined,
      map: null,
      sensorLayer: null,
      eventLayer: null,
      mapInitialized: false,
      dialog: false,
      stationDialog: false,
      selectedSensor: null,
      selectedStation: null,
      secondaryBeepInterval: null,
      soundDialog: true,
      windOrientations: ['Β', 'ΒΑ', 'Α', 'ΝΑ', 'Ν', 'ΝΔ', 'Δ', 'ΒΔ']  //['Β', 'Α', 'Ν', 'Δ'] 
    }
  },
  async mounted() {
    this.heartbeatAudio = new Audio('heartbeat.wav')
    this.alertAudio = new Audio('red_alert.wav')
    this.alertAudio.loop = true
    //this.alertAudio.muted = true

    this.beepAudio = new Audio('beep.wav')

    // await this.preloadEvents()
 
    await this.loadSensors()
    await this.loadStations()
    
    await this.setupMap()
    this.mapInitialized = true

    await this.loadActiveAlarms()

    const self = this
    await this.$nextTick(async () => { await self.connectSignalR() })

    this.secondaryBeepInterval = setInterval(this.tryPlaySecondaryBeep, 7500);

    console.log("[Dashboard :: Mounted] dump of event entries")
    console.log(Object.entries(this.events))

  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();
    }

    this.alertAudio.pause()
    this.beepAudio.pause()

    if (this.secondaryBeepInterval){
      clearInterval(this.secondaryBeepInterval)
    }
  },
  computed: {
    anyUnconfirmedEvent() {
      // return Object.values(this.events).some(x => x.confirmations.length == 0)
      const anyUnconfirmed = this.filteredEvents.some(x => x.activity && x.confirmations.length == 0)
      console.log(this.filteredEvents.filter(x => x.activity && x.confirmations.length == 0))
      return anyUnconfirmed
    },
    filteredSensors() {
      const self = this
      var filtered = this.sensors
      if (this.selectedCamp.trim() !== "") {
        filtered = filtered.filter(x => x.camp.toLowerCase().startsWith(self.selectedCamp.toLowerCase()))
      }

      if (this.campFilters.length > 0) {
        console.log(filtered)
        filtered = filtered.filter(x => this.campFilters.includes(x.camp))
      }

      return filtered
    },
    filteredStations() {
      const self = this
      var filtered = this.weatherStations
      if (this.selectedCamp.trim() !== "") {
        filtered = filtered.filter(x => x.camp.toLowerCase().startsWith(self.selectedCamp.toLowerCase()))
      }

      if (this.campFilters.length > 0) {
        filtered = filtered.filter(x => this.campFilters.includes(x.camp))
      }

      console.log("[Dashboard :: filteredStations] Property computed")
      console.log(filtered)
      console.log(this.weatherStations)
      
      return filtered
    },
    sensorTable() {
      return Object.assign({}, ...this.sensors.map((x) => ({[x.id]: x})));
    },
    stationTable() {
      return Object.assign({}, ...this.weatherStations.map((x) => ({[x.id]: x})))
    },
    filteredEvents() {
      const self = this
      var filtered = Object.values(this.events)
      if (this.selectedCamp.trim() !== "") {
        filtered = filtered.filter(x => x.camp.toLowerCase().startsWith(self.selectedCamp))
      }

      if (this.selectedSensorIndex != null && this.selectedSensorIndex !== "") {
        filtered = filtered.filter(x => self.selectedSensorIndex == x.sensorIndex)
      }

      // filtered = filtered.filter(x => x.confirmations.length == 0)
      // filtered = filtered.filter(x => x.activity)
      return filtered
    },
    availableCamps() {
      const ret  = this.sensors.map(x => x.camp)
      console.log("AVAILABLE CAMPS")
      console.log(ret)
      return ret
    },
    geoJSONSensors() {
      const self = this
      return this.filteredSensors.map(x => ({
        type: "Feature",
        properties: {
          ...x,
          color: self.sensorColorIndicator(x.id),
          //popupContent: `${x.camp} | ${x.id} | [${x.longitude}, ${x.latitude}]`,
          tooltip: `${x.camp} | ${x.description}`
        },
        geometry: {
          type: "Point",
          coordinates: [x.longitude, x.latitude]
        }
      }))
    },
    geoJSONStations() {
      //const self = this
      return this.filteredStations.map(x => ({
        type: "Feature",
        properties: {
          ...x,    // TODO: should we set color somehow? or anything else?
          tooltip: `${x.campName} | ${x.description} | ${this.weatherSummary(x.latestWeather)}`
        },
        geometry: {
          type: "Point",
          coordinates: [x.longitude, x.latitude]
        }
      }))
    },
    geoJSONEvents() {
      var filtered = this.filteredEvents.filter(x => x.activity && x.sensorIndex != 4)
      // filtered = filtered.filter(x => Math.floor(((Date.now() - Date.parse(x.timestamp))/1000)) < 10)
      const features = filtered.map(x => ({
        type: "Feature",
        properties: {
          ...x,
          color: "black",
          popupContent: `${x.sensorIndex}`
        },
        geometry: {
          type: "LineString",
          coordinates: this.sensorEventLineIndicatorCoordinates(x.sensorId, x.sensorIndex)
        }
      }))

      const ret = {
        type: "FeatureCollection",
        features: features
      }
      return ret
    },
    // geoJSONWeatherUpdates() {
    //   var filtered = this.filteredWeatherUpdates.filter(x => x.typeSpec >= 0)
    //   const features = filtered.map(x => ({
    //     type: "Feature",
    //     properties: {
    //       ...x,
    //       // CONITNUE
    //     }
    //   }))
    // }
  },
  watch: {
    geoJSONSensors(geoJSON) {
      if (!this.mapInitialized) {
        return
      }

      this.sensorLayer.clearLayers()
      this.sensorLayer.addData(geoJSON)
    },
    geoJSONEvents (geoJSON) {
      if (!this.mapInitialized) {
        return
      }
      this.eventLayer.clearLayers()
      this.eventLayer.addData(geoJSON)
    }
  },
  methods: {
    weatherSummary(weatherUpdate) {
      console.log("[Weather summary] Got data")
      console.log(weatherUpdate)
      if (weatherUpdate == null) {
        return "Weather data N/A"
      }
      let t = `${weatherUpdate.temperature} °C`
      let w = `${weatherUpdate.windSpeedOneMinAvg * 3.6} Km/h`  // convert m/s to Km/h
      let o = this.degToOrientation(weatherUpdate.windDirection)
      return `${t}, ${w} ${o}`
    },
    degToOrientation(oriDeg) {
      let n = this.windOrientations.length
      let bin_sz = 360/n

      // north is a special case
      if (oriDeg >= 360-bin_sz/2 || oriDeg < bin_sz/2) {
        return this.windOrientations[0]
      }

      // now we can handle everything else
      let low = bin_sz/2
      for (var i=1; i<n; i++) {
        low += bin_sz
        if (oriDeg < low) {
          return this.windOrientations[i]
        }
      }

      // if you reach this, something is wrong!
      return `Wind orientation error @ ${oriDeg}`
    },
    convertTime(timestamp) {
      const UTC_time = new Date(timestamp.split('.')[0]+"+00:00")
      const GR_time = new Date(UTC_time).toLocaleTimeString('el-GR', {timeZone:'Europe/Athens', hour: '2-digit', minute:'2-digit', hour12: false})
      return GR_time
    },
    autofocus() {
      const sensorLat = this.sensors.map(x => x.latitude)
      const sensorLng = this.sensors.map(x => x.longitude)

      const minLat = Math.min(...sensorLat)
      const maxLat = Math.max(...sensorLat)

      const minLng = Math.min(...sensorLng)
      const maxLng = Math.max(...sensorLng)

      const focusPoint = [(minLat + maxLat) / 2, (minLng + maxLng) / 2]
      this.map.panTo(focusPoint)
    },
    clearFilters(){
      this.campFilters = []
      this.selectedCamp = ''
    },
    filter() {
      this.campFilters = this.$refs.campPicker.selectedCamps
      this.autofocus()
    },
    playHeartbeatSound() {
      this.heartbeatAudio.pause()
      this.heartbeatAudio.currentTime = 0
      this.heartbeatAudio.play()
    },
    alertSoundCheck() {
      const isPlaying = !this.alertAudio.paused
      
      // TODO: verify behavior error in alert shutdown AND test the following functionality as a possible correction
      // stop the alert audio in 2 cases:
      //   a. if there are no unconfirmed events remaining
      // OR
      //   b. if there are no "ON" alarm events remaining
      const anyActiveEvents = this.filteredEvents.filter(x => (x.sensorIndex < 3 || x.sensorIndex > 4 )).some(x => x.activity)
      if (!this.anyUnconfirmedEvent || !anyActiveEvents) {
        this.alertAudio.pause()
        this.alertAudio.currentTime = 0
        return
      }

      if (isPlaying) {
        return
      }

      // this.alertAudio.currentTime = 0
      if (this.soundDialog) {
        return
      }

      this.alertAudio.play()
      this.beepAudio.pause()
    },
    tryPlaySecondaryBeep() {
      if (!this.alertAudio.paused) {
        return
      }

      const anyEventStillUp = this.filteredEvents.filter(x => (x.sensorIndex < 3 || x.sensorIndex > 4)).some(x => x.activity)
      if (anyEventStillUp) {
        if (this.soundDialog) {
          return
        }
        this.beepAudio.play()
      }
    },
    async confirmAlert(event) {
      if (event.sensorIndex !== 4 && this.$store.state.user.isAdmin) {
        return
      }

      try {
        await this.$axios.post(`/eventConfirmations/${event.id}`)
        const eventKey = `${event.sensorId}-${event.sensorIndex}`;
        if (event.sensorIndex == 4){
          Vue.delete(this.events, eventKey)
          // delete this.events[eventKey]
          return
        }

        this.events[eventKey].confirmations.unshift([new Date().toUTCString()])
        this.alertSoundCheck()
      } catch (e) {
        console.log(e)
        this.error = `Failed to confirm event: please contact an administrator. Error: ${e.message}`
      }
    },
    sensorColorIndicator(sensorId) {
      for (const idx in [0, 1, 2, 3, 4, 5]){
        const evt = this.events[`${sensorId}-${idx}`]
        if (evt === undefined) {
          continue
        }
        if (idx == 4) {
          return "green"
        }

        if (evt.activity) {
          if (idx == 3) {
            return "yellow"
          }
          else if (idx == 5) {
            return "orange"
          }
          return "red"
        }
      }

      return "blue"
    },
    sensorEventLineIndicatorCoordinates(sensorId, sensorIndex) {
      const sensor = this.sensorTable[sensorId]
      const degrees = sensor.orientations[sensorIndex < 3 ? sensorIndex : 0]
      const coneDegrees = 60
      const radStart =  (degrees - (coneDegrees / 2)) * (Math.PI / 180)
      const radEnd =  (degrees + (coneDegrees / 2)) * (Math.PI / 180)

      const root = [sensor.longitude, sensor.latitude]

      const offset = 2.5 * 1e-3;
      const coneStart = [sensor.longitude + Math.sin(radStart) * offset, sensor.latitude + Math.cos(radStart) * offset]
      const coneEnd = [sensor.longitude + Math.sin(radEnd) * offset, sensor.latitude + Math.cos(radEnd) * offset]

      if (sensorIndex >= 3) {
        return [
          root, root, root, root
        ]
      }
      else {
        return [
          root, coneStart, root, coneEnd
        ]
      }
    },
    closeSensorDetailsDialog() {
      this.dialog = false
      this.selectedSensor = null
    },
    closeStationDetailsDialog() {
      this.stationDialog = false
      this.selectedStation = null
    },
    async setupMap () {
      const self = this
      this.map = L.map("mapContainer").setView([37.843071, 23.812587], 12);

      L.tileLayer('http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {}).addTo(this.map);

      this.sensorLayer = L.geoJSON([],{
        pointToLayer: this.sensorPointToLayer
      }).addTo(this.map)

      this.sensorLayer.on('click', this.onSensorClick)

      this.sensorLayer.addData(this.geoJSONSensors)

      // var eventMarkerOptions = {
      //     radius: 12,
      //     fillColor: "#ff7800",
      //     color: "#000",
      //     weight: 1,
      //     opacity: 0.8,
      //     fillOpacity: 0.8
      // };

      this.eventLayer = L.geoJSON([], 
      {
        onEachFeature: function (feature, layer) {
          if (layer instanceof L.Polyline) {
            layer.setStyle({
              'color': feature.properties.color
            })
          }
        }
      }
        ).addTo(this.map)

      this.eventLayer.addData(this.geoJSONEvents)

      console.log("[Dashboard :: SetupMap] Setting up stations in map object")
      this.stationLayer = L.geoJSON([],{
        pointToLayer: this.stationPointToLayer
      }).addTo(this.map)
      this.stationLayer.on('click', this.onStationClick)
      this.stationLayer.addData(this.geoJSONStations)

      await this.$nextTick(async () => { 
        self.sensorLayer.bringToBack()
        self.eventLayer.bringToFront()
        self.stationLayer.bringToBack()
       })      
    },
    sensorPointToLayer(feature, latlng) {
      return L.circleMarker(latlng, {color: feature.properties.color}).bindTooltip(feature.properties.tooltip, {permament: true}).openTooltip();
    },
    stationPointToLayer(feature, latlng) {
      return L.marker(latlng).bindTooltip(feature.properties.tooltip, {permament: true}).openTooltip();
    },
    onSensorClick(e) {
      const sensorInfo = e.layer.feature.properties
      this.selectedSensor = sensorInfo
      this.dialog = true
    },
    onStationClick(e) {
      const stationInfo = e.layer.feature.properties
      this.selectedStation = stationInfo
      this.stationDialog = true
      console.log("[Dashboard :: onStationClick] A station was clicked")
      console.log(stationInfo)
    },

    //Weather station utilities
    async loadStations() {
      var q = {}
      var campsToLoad = []

      if (!(this.$store.state.user.isAdmin
      || this.$store.state.user.isCampMaster)) {
        // if not, restrict camps to user-specific
        campsToLoad = this.$store.state.user.camps
      }

      // check if a camp has been explicitly selected
      if (this.selectedCamp.trim() !== "") {
        campsToLoad = [this.selectedCamp]
      }

      // if any restrictions apply, load sensors per camp
      if (campsToLoad.length > 0) {
        // CAUTION: probably not a good idea to do forEach here
        // reason being that await/async doesn't play that nice for
        // some reason...
        for (var camp of campsToLoad) {
          try {
            q.camp = camp
            const response = await this.$axios.get('/weatherStations', { params: {...q}})
            this.weatherStations.push.apply(this.weatherStations, response.data)
          } catch (e) {
            console.log("[Dashboard::loadStations] Exception caught")
            console.log(e.response)
            this.error = e.response.data
          }
        }
      } else {  // for authorities only, and if no selection was made, load everything
        try {
          const response = await this.$axios.get('/weatherStations')
          this.weatherStations = response.data
        } catch (e) {
          console.log(e.response)
          this.error = e.response.data
        }
      }

      for (var s of this.weatherStations) {
        try {
          const response = await this.$axios.get('/weatherUpdates/latest/', { params: {stationId: s.id}})
          if (response.status == "204") {
            s.latestWeather = null
          } else {
            s.latestWeather = response.data
          }
          console.log(`[Dashboard :: loadStations] Got latest weather:`)
          console.log(s.latestWeather)
        } catch (e) {
          console.log("[Dashboard :: loadStations] Exception caught")
          console.log(e.response)
          this.error = e.response.data
        }
        if (s.description == null || s.description.length == 0) {
          s.description = "Basic weather station"
        }
      }

      console.log("[Dashboard :: loadStations] Load complete")
      console.log(this.weatherStations)
    },

    // Fire sensor utilities
    async loadSensors() {
      var q = {}
      var campsToLoad = []

      // check if we have elevated authorities
      if (!(this.$store.state.user.isAdmin
      || this.$store.state.user.isCampMaster)) {
        // if not, restrict camps to user-specific
        campsToLoad = this.$store.state.user.camps
      }

      // check if a camp has been explicitly selected
      if (this.selectedCamp.trim() !== "") {
        campsToLoad = [this.selectedCamp]
      }

      // if any restrictions apply, load sensors per camp
      if (campsToLoad.length > 0) {
        // CAUTION: probably not a good idea to do forEach here
        // reason being that await/async doesn't play that nice for
        // some reason...
        for (var camp of campsToLoad) {
          try {
            q.camp = camp
            const response = await this.$axios.get('/sensors', { params: {...q}})
            this.sensors.push.apply(this.sensors, response.data)
          } catch (e) {
            console.log("[Dashboard::loadSensors] Exception caught")
            console.log(e.response)
            this.error = e.response.data
          }
        }
      } else {  // for authorities only, and if no selection was made, load everything
        try {
          const response = await this.$axios.get('/sensors')
          this.sensors = response.data
        } catch (e) {
          console.log(e.response)
          this.error = e.response.data
        }
      }
    },
    async loadActiveAlarms () {
      var campsToLoad = []

      // check if we have elevated authorities
      if (!(this.$store.state.user.isAdmin
      || this.$store.state.user.isCampMaster)) {
        // if not, restrict camps to user-specific
        campsToLoad = this.$store.state.user.camps
      }

      // check if a camp has been explicitly selected
      if (this.selectedCamp.trim() !== "") {
        campsToLoad = [this.selectedCamp]
      }

      // load all active alarms
      let activeSensorEvents = {}
      try{
        const response = await this.$axios.get('/sensorEvents/activeAlarms', { params: {showUncofirmedOnly: false, campNameList: campsToLoad} })
        activeSensorEvents = response.data
      } catch (e) {
        console.log(e.response)
        this.error = e.response.data
      }

      // find correponding sensor for first event and pan map to it
      if (activeSensorEvents[0] === undefined) {
        console.log("[Dashboard :: loadActiveAlarms] No active sensor events available.")
        return
      }
      const sensor = this.sensors.find(elem => elem["id"] == activeSensorEvents[0].sensorId)
      
      if (!this.$store.state.user.isAdmin){
        this.map.panTo([sensor.latitude, sensor.longitude])
      }

      // next goal: update current event list with the new ones
      // first compute the event keys
      const keys = activeSensorEvents.map(x => `${x.sensorId}-${x.sensorIndex}`)

      // then match them to their payload
      let payload = {}
      activeSensorEvents.forEach((x, i) => {
        payload[keys[i]] = x
      });
      
      // finally update the events data instance
      this.events = Object.assign({}, this.events, payload)
      this.alertSoundCheck()
      
      // TODO what should the dismissal button actually do??
    },
    async preloadEvents() {
      const MS_PER_MINUTE = 60000;
      const fiveMinutesBefore = new Date(Date.now() - 5 * MS_PER_MINUTE);

      var q = {
        fromDate: fiveMinutesBefore.toISOString()
      }

      if (!(this.$store.state.user.isAdmin
      || this.$store.state.user.isCampMaster)) {
        q.camp = this.$store.state.user.camps[0]
      }

      try{
        const response = await this.$axios.get('/sensorEvents', { params: q })
        var events = response.data.reverse()
        var eventsToUpdate = {};

        for (const e of events) {
          eventsToUpdate[e.sensorId] = e;
        }

        this.events = Object.assign({}, eventsToUpdate)
      } catch (e) {
        console.log(e.response)
        this.error = e.response.data 
      }
    },

    
    async connectSignalR() {
      const self = this;
      this.connection = new HubConnectionBuilder()
                          .withUrl(`${url}/hubs/sensorEvents?jwt=${this.$store.state.user.jwt}`)
                          .configureLogging(LogLevel.Information)
                          .build()
      
      this.weatherLink = new HubConnectionBuilder()
                          .withUrl(`${url}/hubs/weatherUpdates?jwt=${this.$store.state.user.jwt}`)
                          .configureLogging(LogLevel.Information)
                          .build()

      this.weatherLink.on('ReceiveWeatherUpdate', async (weatherUpdateResponse) => {
        console.log('receive weather update')
        console.log(weatherUpdateResponse)

        const key = `${weatherUpdateResponse.Id}`
        if (weatherUpdateResponse.TypeSpec != 0) {
          if (!self.weatherUpdates[key]) {
            var payload = {}
            payload[key] = weatherUpdateResponse

            self.weatherUpdates = Object.assign({}, self.weatherUpdates, payload)

            //const station = self.stationTable[weatherUpdateResponse.stationId]
            if (!self.$store.state.user.isAdmin){
              await self.loadStations()
            }
          }
        }
      })

      this.connection.on('ReceiveSensorEvent', (sensorEventResponse) => {
        console.log('receive sensor event')
        console.log(sensorEventResponse)

        const key = `${sensorEventResponse.sensorId}-${sensorEventResponse.sensorIndex}`
        if (!sensorEventResponse.activity) {
          if (self.events[key]) {
            self.events[key].activity = false
            self.alertSoundCheck()
            return
          }
        }

        if (!sensorEventResponse.confirmations) {
          sensorEventResponse['confirmations'] = []
        }

        // new event
        var payload = {}
        payload[key] = sensorEventResponse

        self.events = Object.assign({}, self.events, payload)

        const sensor = self.sensorTable[sensorEventResponse.sensorId]
        if (!self.$store.state.user.isAdmin){
          self.map.panTo([sensor.latitude, sensor.longitude])
        }

        if (sensorEventResponse.sensorIndex == 4) {
          self.playHeartbeatSound()
          return
        }
        
        self.alertSoundCheck()
      })
  
      this.connection.on('ReceiveConfirmation', (confirmationEventResponse) => {
        console.log(confirmationEventResponse)

        const sensorId = confirmationEventResponse.event.sensorId
        const timestamp = confirmationEventResponse.timestamp
        const eventKey = `${sensorId}-${confirmationEventResponse.event.sensorIndex}`
        if (!(eventKey in this.events)) {
          return
        }

        this.events[eventKey].confirmations.unshift(timestamp)

        if (confirmationEventResponse.event.sensorIndex == 4) {
          delete this.events[eventKey]
          return
        }

        this.alertSoundCheck()
      })

      try {
          await this.connection.start()
      } catch (e) {
        this.error = "SignalR failed to connect"
        console.log(`Failed to connect with hub ${e.message}`)
      }
    },
    async disconnectSignalR() {
      console.log("[Dashboard :: SignalR] CAUTION: disconnecting from SignalR!!!")
      if (this.connection && this.connection.connection.connectionState == 1) {
        this.connection.stop()
      }

      this.events = []
    }
  }
}
</script>
